var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 876,
    height: 1000,
    viewBox: "0 0 876 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M563 125C563 194.036 507.036 250 438 250C368.964 250 313 194.036 313 125C313 55.9644 368.964 0 438 0C507.036 0 563 55.9644 563 125Z",
    fill: "#F8F8F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M469.25 968.75C469.25 986.009 455.259 1000 438 1000C420.741 1000 406.75 986.009 406.75 968.75C406.75 951.491 420.741 937.5 438 937.5C455.259 937.5 469.25 951.491 469.25 968.75Z",
    fill: "#F8F8F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M450.089 533.668C478.821 539.299 500.5 564.618 500.5 595C500.5 617.006 489.127 636.356 471.937 647.492L398.136 713.509C410.656 717.719 424.062 720 438 720C507.036 720 563 664.036 563 595C563 549.103 538.263 508.983 501.394 487.245L450.089 533.668Z",
    fill: "#F8F8F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M476.844 476.153C464.617 472.159 451.561 470 438 470C368.964 470 313 525.964 313 595C313 641.268 338.138 681.665 375.501 703.278L427.133 656.559C397.796 651.415 375.5 625.811 375.5 595C375.5 572.626 387.256 552.998 404.929 541.957L476.844 476.153Z",
    fill: "#F8F8F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M453.752 783.252C480.644 790.234 500.5 814.673 500.5 843.75C500.5 878.268 472.518 906.25 438 906.25C403.482 906.25 375.5 878.268 375.5 843.75C375.5 823.712 384.93 805.877 399.594 794.439L476.947 726.187C464.69 722.172 451.599 720 438 720C368.964 720 313 775.964 313 845C313 914.036 368.964 970 438 970C507.036 970 563 914.036 563 845C563 799.905 539.121 760.388 503.318 738.403L453.752 783.252Z",
    fill: "#F8F8F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 375C250.5 444.036 194.536 500 125.5 500C56.4644 500 0.5 444.036 0.5 375C0.5 305.964 56.4644 250 125.5 250C194.536 250 250.5 305.964 250.5 375Z",
    fill: "#F8F8F8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M875.5 375C875.5 444.036 819.536 500 750.5 500C681.464 500 625.5 444.036 625.5 375C625.5 305.964 681.464 250 750.5 250C819.536 250 875.5 305.964 875.5 375Z",
    fill: "#F8F8F8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M168 355.658L708 340.647V492.5C497.51 415.994 378.751 415.747 168 492.5V355.658Z",
    fill: "#F8F8F8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M700.125 387.991H168.002V257.5C378.489 334.014 497.248 334.267 708.002 257.522L700.125 387.991Z",
    fill: "#F8F8F8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M340.145 769.033C350.006 750.503 449.856 665.66 485.066 635.77C520.277 605.879 573.692 634.865 524.924 683.482C476.155 732.099 410.379 785.1 388.471 805.764C366.563 826.429 330.284 787.564 340.145 769.033Z",
    fill: "#F8F8F8"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M345.823 509.71L482.459 386.076L525.113 433.216L388 556.875L345.823 509.71Z",
    fill: "#F8F8F8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M536.132 921.689C532.493 931.375 462.134 990.759 453.177 995.979C444.22 1001.2 432.599 962.867 432.599 962.867L515.068 898.424C515.068 898.424 539.771 912.004 536.132 921.689Z",
    fill: "#F8F8F8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M425.805 996.982C413.988 996.032 346.908 932.858 341.322 923.996C335.735 915.134 385.415 887.837 385.415 887.837L457.526 963.691C457.526 963.691 437.622 997.933 425.805 996.982Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaro);
export default __webpack_public_path__ + "static/media/claro.a4bf3d2cc4fdd7908ccbab939e43e38e.svg";
export { ForwardRef as ReactComponent };